export enum Claim {
  __Profile_Owner = '__Profile_Owner',
  Profile_Add = 'Profile_Add',
  Profile_View = 'Profile_View',
  Profile_Edit = 'Profile_Edit',
  Profile_Delete = 'Profile_Delete'
}
